import statEmployees from "@/assets/icons/stat-employees.png";
import statHubs from "@/assets/icons/stat-hubs.png";
import statAttrition from "@/assets/icons/stat-attrition.png";
import statExperience from "@/assets/icons/stat-experience.png";

const statsData = [
{ icon: statEmployees, value: "500+", label: "Employees" },
{ icon: statHubs, value: "3 Major Hubs", label: "Johannesburg, Durban, Cape Town" },
{ icon: statAttrition, value: "<5%", label: "Agent Attrition Rate" },
{ icon: statExperience, value: "25+ Years", label: "Industry Experience" }];


export function StatsBand() {
  return (
    <section className="relative z-10">
      





















      
    </section>);

}